import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  baseUrl: string;

  constructor(
    private httpclient: HttpClient
  ) {
      this.baseUrl = environment.portalApiUrl;
  }

  getLanguage(uid: number): any {
    return this.httpclient.get<any>(this.baseUrl + '/api/language/' + uid)
                          .pipe(catchError(this.handleError));
  }

  private handleError(error: any): any {
    console.error('error', error);
    return error;
  }

}
